import { useContext, useEffect, useState } from "react";
// import { AuthType } from "../../shared/constants/AppEnums";
// import { defaultUser } from "../../shared/constants/AppConst";
// import jwtAxios from "../services/ApiConfig";
// import { AuthUser } from "../../types/models/AuthUser";
import { fetchStart, fetchSuccess, useInfoViewActionsContext } from "../core/InfoView/InfoViewContext";
import AppContext from "./AppContext";
import AppContextPropsType from "../../types/AppContextPropsType";
import {User as HPUser} from '../../model/User';
import {StorageKeyForJWT, setJWT, StorageKeyForRefreshToken, setRefreshToken} from '../../api/Config';
// import { RoutePermittedRole } from "shared/constants/AppConst";
import { decode } from 'jsonwebtoken';

// export const useAuthToken = (): [boolean, AuthUser | null] => {
//   const [loading, setLoading] = useState(true);
//   // const {user, updateAuthUser, HP_JWT, HPUser, setHPUser} = useContext<AppContextPropsType>(AppContext);
//   const { updateAuthUser, HP_JWT, HPUser, setHPUser } = useContext<AppContextPropsType>(AppContext);
//   const dispatch = useInfoViewActionsContext()!;

//   useEffect(() => {
//     const validateAuth = async () => {
//       dispatch(fetchStart());
//       const token = localStorage.getItem('token');
//       if (!token) {
//         dispatch(fetchSuccess());
//         return;
//       }
//       jwtAxios.defaults.headers.common['x-auth-token'] = token;
//       try {
//         const res = await jwtAxios.get('/auth');

//         dispatch(fetchSuccess());
//         updateAuthUser({
//             authType: AuthType.JWT_AUTH,
//             displayName: res.data.name,
//             email: res.data.email,
//             role: defaultUser.role,
//             token: res.data._id,
//             uid: res.data._id,
//             photoURL: res.data.avatar,
//           });
//         return;
//       } catch (err) {
//         dispatch(fetchSuccess());
//         return;
//       }
//     };

//     const checkAuth = () => {
//       Promise.all([validateAuth()]).then(() => {
//         setLoading(false);
//       });
//     };
//     checkAuth();
//   }, [dispatch,updateAuthUser]);

//   return [loading, user];
// };

// export const useAuthUser = (): AuthUser | null => {
//   const {user} = useContext<AppContextPropsType>(AppContext);
//   if (user) {
//     return user;
//   }
//   return null;
// };

export const useHPAuth = (): [boolean, HPUser | null] => {
  const [loading, setLoading] = useState(true);
  const {HPUser, setHPUser} = useContext<AppContextPropsType>(AppContext);
  const dispatch = useInfoViewActionsContext()!;

  useEffect(() => {
    const validateAuth = async () => {
      dispatch(fetchStart());
      const token = localStorage.getItem(StorageKeyForJWT);
      const refreshToken = localStorage.getItem(StorageKeyForRefreshToken);
      if (!token || !refreshToken) {
        setHPUser(null)
        dispatch(fetchSuccess());
        return;
      }

      const decodedToken = decode(token);
      if ( decodedToken ) {
        if ( typeof decodedToken === "object" ) {
          if ( decodedToken.exp ) {
            if ( decodedToken.exp < Math.trunc(Date.now()/1000) ) {
              setHPUser(null)
              dispatch(fetchSuccess());
              return;
            }
          } else {
            setHPUser(null)
              dispatch(fetchSuccess());
              return;
          }
        } else {
          setHPUser(null)
          dispatch(fetchSuccess());
          return;
        }
      } else {
        setHPUser(null)
        dispatch(fetchSuccess());
        return;
      }
          //jwtAxios.defaults.headers.common['x-auth-token'] = token;
      setJWT(token);
      setRefreshToken(refreshToken)
      try {
        //const res = await jwtAxios.get('/auth');

        //dispatch(fetchSuccess());
        /*updateAuthUser({
          authType: AuthType.JWT_AUTH,
          displayName: res.data.name,
          email: res.data.email,
          role: defaultUser.role,
          token: res.data._id,
          uid: res.data._id,
          photoURL: res.data.avatar,
        });*/
        //setHPUser({jwt: token, user: {}});

        const user = localStorage.getItem('loggedUser') ? JSON.parse(localStorage.getItem('loggedUser') as string) as HPUser : null as unknown as HPUser;
        setHPUser({user: user, jwt: token, rt:refreshToken});
        // setHPUser({
        //   user: {
        //     ...user,
        //     ruolo: RoutePermittedRole.Freelancer,
        //   },
        //   jwt: token,
        //   rt: refreshToken
        // });
        dispatch(fetchSuccess());
        return;
      } catch (err) {
        setHPUser(null)
        dispatch(fetchSuccess());
        return;
      }
    };

    const checkAuth = () => {
      Promise.all([validateAuth()]).then(() => {
        setLoading(false);
      });
    };
    checkAuth();
  }, [dispatch,setHPUser]);

  return [loading, HPUser];
};

export const useHPUser = (): HPUser | null => {
  const {HPUser} = useContext<AppContextPropsType>(AppContext);
  if (HPUser) {
    return HPUser;
  }
  return null;
};
